import { Component } from '@angular/core';
import { CafeDashboardComponent } from '@/project/dashbord/cafe-dashboard/cafe-dashboard';

@Component({
    selector: 'app-dashboard',
    imports: [CafeDashboardComponent],
    template: `<app-cafe-dashboard />`
})
export class Dashboard {}
